// @ts-nocheck
import React, { Component } from 'react';
import { inject, observer } from "../../stores/mobx-compat";

import CaptureLogo from '../ui/CaptureLogo';
import Button from '../ui/Button';
import OTPInput from '../ui/OTPInput';

class TwoFAPage extends Component {
  state = { code: '' };

  submit = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    this.props.store.auth.verifyCode(this.state.code);
  }

  render() {
    return (
      <div className="mov-app auth-root" style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 24 }}>
        <div style={{ width: '100%', maxWidth: 420 }}>
          <div className="flex justify-center mb-6">
            <CaptureLogo style={{ width: 160 }} />
          </div>
          <div
            className="text-center"
            style={{
              background: 'var(--mov-paper)',
              border: '1px solid var(--mov-line)',
              borderRadius: 14,
              padding: 28,
              boxShadow: 'var(--mov-shadow-card)',
            }}
          >
            <div className="mov-mono text-[11px] uppercase tracking-wider text-mov-accent-ink mb-2">
              Two-factor
            </div>
            <h1 className="mov-display m-0 mb-2" style={{ fontSize: 28, lineHeight: 1.1 }}>
              Enter your <em>code</em>.
            </h1>
            <p className="m-0 mb-5 text-[13px] text-mov-ink-soft">
              We sent a 6-digit code to your device.
            </p>

            <form onSubmit={this.submit}>
              <div className="flex justify-center mb-5">
                <OTPInput
                  value={this.state.code}
                  onChange={(v) => this.setState({ code: v })}
                  autoFocus
                />
              </div>
              <Button
                type="submit"
                variant="primary"
                className="w-full justify-center"
                loading={this.props.store.auth.loading}
                disabled={this.props.store.auth.loading}
              >
                Verify
              </Button>
            </form>

            <div className="mt-4 text-[12.5px] text-mov-ink-soft">
              <button
                type="button"
                onClick={this.props.store.auth.sendCode}
                className="text-mov-accent-ink underline cursor-pointer"
                style={{ background: 'transparent', border: 0, padding: 0 }}
              >
                Resend code
              </button>
              {' · '}
              <button
                type="button"
                onClick={this.props.store.auth.signOut}
                className="text-mov-accent-ink underline cursor-pointer"
                style={{ background: 'transparent', border: 0, padding: 0 }}
              >
                Use a different account
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default inject('store')(observer(TwoFAPage));
